var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chartdata)?_c('Chart',{ref:"chart",attrs:{"chart-data":_vm.chartdata,"options":_vm.otherOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }